export default __webpack_public_path__ + "static/media/gen-ext-es.d5100e2b.png";